import { MUTATION } from '../config.js';
import { query } from './http-methods.js';

const mutationHandlers = async (mutation, setPrevArticle, setIsLoading, mutationProps, csrfToken, cartVersion) => {
    let result;
    switch (mutation) {
        case MUTATION.SET_ARTICLE_QUANTITY: {
            const payload = mutationProps;
            if (payload.quantity === 0) {
                setPrevArticle({
                    ...payload,
                    isSp: false,
                });
            }
            setIsLoading(true);
            result = await query.setArticleQuantity(payload, cartVersion);
            break;
        }
        case MUTATION.SET_SAVING_PLAN_ARTICLE: {
            const { articleId, quantity, articleName, ...rest } = mutationProps;
            if (quantity === 0) {
                setPrevArticle({ articleId, articleName, isSp: true });
            }
            result = await query.setSavingsPlanArticle({ articleId, quantity, ...rest }, cartVersion);
            break;
        }
        case MUTATION.SET_SHIPPING_COUNTRY: {
            const { country, zipCode } = mutationProps;
            setIsLoading(true);
            result = await query.setShippingCountry({ country, zipCode }, cartVersion);
            break;
        }
        case MUTATION.SET_COUPON: {
            const { couponCode } = mutationProps;
            result = await query.setCoupon({ couponCode }, cartVersion);
            break;
        }
        case MUTATION.DELETE_COUPON: {
            const { couponCode } = mutationProps;
            result = await query.deleteCoupon({ couponCode }, cartVersion);
            break;
        }
        case MUTATION.SET_FREE_SAMPLE_ARTICLE: {
            const { articleId, quantity } = mutationProps;
            result = await query.setFreeSampleArticle({ articleId, quantity }, cartVersion);
            break;
        }
        case MUTATION.SET_SUBSCRIPTION_INTERVAL: {
            const { subscriptionInterval } = mutationProps;
            result = await query.setSubscriptionInterval({ subscriptionInterval }, cartVersion);
            break;
        }
        case MUTATION.REMOVE_SUBSCRIPTION: {
            result = await query.removeSubscription(cartVersion);
            break;
        }
        case MUTATION.CREATE_BASIC_GUEST_ACCOUNT: {
            const { email } = mutationProps;
            setIsLoading(true);
            result = await query.createBasicGuestAccount({ email }, csrfToken, cartVersion);
            break;
        }
        case MUTATION.UPADTE_GUEST_ACCOUNT_EMAIL: {
            const { email } = mutationProps;
            setIsLoading(true);
            result = await query.updateGuestAccountEmail({ email }, cartVersion);
            break;
        }
        case MUTATION.SET_ADDRESSES: {
            setIsLoading(true);
            result = await query.setAddresses(mutationProps, cartVersion);
            break;
        }
        case MUTATION.DELETE_SAVED_BANCONTACT: {
            setIsLoading(true);
            result = await query.deleteSavedBancontact(mutationProps, cartVersion);
            break;
        }
        case MUTATION.DELETE_SAVED_CARD: {
            setIsLoading(true);
            result = await query.deleteSavedCard(mutationProps, cartVersion);
            break;
        }
        case MUTATION.UPDATE_PREFERRED_PAYMENT: {
            setIsLoading(true);
            result = await query.updatePreferredPayment(mutationProps, cartVersion);
            break;
        }
        case MUTATION.SET_DELIVERY_SERVICE: {
            setIsLoading(true);
            result = await query.setDeliveryService(mutationProps, cartVersion);
            break;
        }
        default:
            throw new Error(`No handler found for mutation: ${mutation}`);
    }
    return result;
};

export { mutationHandlers };
//# sourceMappingURL=mutation-handlers.js.map
